const dlc = {
    /**Global space, this object cannot be deleted */
    global: {
        input_search: 'Search',
        input_export: 'Export',
        input_filter: 'Filter',
        input_sync: 'Refresh',
        input_add: 'Add',
        input_copy: 'Copy',
        input_edit: 'Edit',
        input_enable: 'enable',
        input_disable: 'disable',
        input_confirm: 'Confirm',
        input_cancel: 'Cancel',
        msg_copy_success: 'Copy Successly',
        label_confirm_delete: 'Data is unrecoverable after the Deletion, continue?',
        label_confirm_cancel: 'Doing this will lose all current input, continue?',
        label_nav_create: 'Creation',
        label_nav_edit: 'Editing',
        label_yes: 'Yes',
        label_no: 'No',
        label_warn: 'Hint',
        lang_eng: 'English',
        lang_cn: 'Chinese',
        enum_currency_THB: '฿',
        enum_currency_USD: '$',
        enum_currency_CNY: '¥',
        require: 'Please enter {0}',
        require_phoneNumber: 'Please enter the correct format of phone number',
    },

    /**Routing page */
    router: {
        addStock: 'Add stock',
        editStock: 'Edit stock',
        stockList: 'Stock',
        stockDetail: 'Stock Details',
        productDetail: 'Product information',
        brand: 'Brand management'
    },

    /**Homepage */
    home: {
        welcome_1: 'Welcome to Fanslink CDMS',
        welcome_2: ' ',
        input_account_hint: 'Please enter the user name',
        input_password_hint: 'Please enter your password',
        input_login: 'Login',
        input_remember: 'Remember password',
        link_forget: 'Forgot your password? ',
        link_regist_1: 'No account? go',
        link_regist_2: 'Register',
        require_account: 'The account cannot be empty',
        require_password: 'Password cannot be empty',
    },

    // advert management
    advert: {
        form: {
            ph_searchTip: 'Please enter advert name',
            ph_status: 'Status',
            enum_active: 'Active',
            enum_disable: 'Disable',
            input_search: 'Search',
            input_add: 'Add advert',
            th_num: '#',
            th_pic: 'Picture',
            th_name: 'Name',
            th_jumpType: 'Jump Type',
            th_sort: 'Sort',
            th_createTime: 'Create Time',
            th_status: 'Status',
            th_opr: 'Operation',
            input_edit: 'Edit',
            input_delete: 'Delete',
            ph_tip:'*Only display the highest ranked advertising map in normal status'
        },
    },

    productnew:{
        form:{
            th_pic: 'Product Picture',
            th_name: 'Product Name',
            th_barcode:'Barcode',
            th_skuCode:'SKU',
            th_serviceMonth: 'Period Of Warranty (month)',
            th_operatingEN: 'Operation Manual (EN)',
            th_operatingTHAI: 'Operation Manual (THAI)',
            th_videoUrl:'Video',
            th_remark: 'Remarks',
            th_createTime: 'Create Time',
            th_oper: 'Operation',
            input_delete: 'Delete',
            ph_searchTip: 'Please enter the product name/barcode/sku to search'
        },
        add:{
            th_img: 'Product Picture',
            th_name: 'Product Name',
            th_barcode:'Barcode',
            th_sku:'SKU',
            th_serviceMonth: 'Period Of Warranty',
            th_oper: 'Operation',
            th_warranty: 'Period Of Warranty',
            oper_add: 'Add',
            oper_added: 'Added',
            label_code:'Barcode',
            label_total:'Total',
            label_nameEN: 'Product Name (EN)',
            label_nameTH: 'Product Name (TH)',
            label_barCode:'Barcode',
            label_skuCode:'SKU Code',
            label_serviceMonth: 'Warranty Period(month)',
            label_video:'Video',
            label_img: 'Product Picture',
            label_operEN: 'Operation Manual (EN)',
            label_operTH: 'Operation Manual (TH)',
            require_nameEN: 'Please fill in the name',
            require_nameTH: 'Please fill in the name',
            require_barCode: 'Please fill in barCode',
            require_sku: 'Please fill in skuCode',
            require_fileList: 'Please upload pictures',
        }
    },

    admin:{
        form:{
            th_username:'User Name',
            th_roleName:'Role',
            th_createTime:'Create Time',
            th_status:'Status',
            th_opr:'Operation',
            enum_active:'Active',
            enum_disable:'Disable',
            input_edit:'Edit',
            ph_searchTip:'User Name',
            input_search:'Search',
            input_add:'Add',
            label_edit:'Edit',
            // roleList
            th_name: 'Role',
            th_remark: 'Remark',
        },
    },

    // user management
    user: {
        enum_female: 'Female',
        enum_male: 'Male',
        enum_secret: 'Secret',
        form: {
            ph_searchTip: 'Please enter username/Email/mobile',
            ph_status: 'Status',
            enum_active: 'Active',
            enum_disable: 'Disable',
            input_search: 'Search',
            input_export: 'Export',
            th_username: 'User Name',
            th_name: 'Nick Name',
            th_gender: 'Gender',
            th_birthday: 'Birthday',
            th_mobile: 'Mobile',
            th_email: 'Email',
            th_address: 'Address',
            th_productCount: 'Registered Product Count',
            th_createTime: 'Create Time',
            th_loginAt: 'Last Login Time',
            th_status: 'Status',
            th_opr: 'Operation',
            input_edit: 'Edit',
            input_detail: 'Details',
            input_active: 'Active',
            input_disable: 'Disable',
            input_delete: 'Delete',
            label_detail: 'Details',
            label_edit: 'Edit',
        },
        detail: {
            lable_username: 'User Name',
            lable_password: 'Password',
            lable_firstname: 'First Name',
            lable_lastname: 'Last Name',
            lable_nickname: 'Nick Name(optional)',
            lable_gender: 'Gender',
            lable_birth: 'Date of birth',
            lable_mobile: 'Mobile Number',
            lable_email: 'Email',
            lable_address: 'Address',
            input_editPaddword: 'Edit',
            lable_rePasswd: 'Confirm Password',
            lable_passwd: 'New Password',
            require_password: "Password don't match",
        },
        productForm: {
            ph_picoSearchTip: 'Please enter name/Barcode/SKU',
            ph_picoUserSearchTip: 'Please enter Email/mobile',
            ph_productSearchTip: 'Please enter productID/name/Barcode/SKU',
            ph_userSearchTip: 'Please enter username/Email/mobile',
            ph_place: 'Purchase from',
            input_edit: 'Edit',
            input_view: 'Detail',
            input_delete: 'Delete',
            th_id: 'ID',
            th_img: 'Product Picture',
            th_productName: 'Product Name',
            th_code: 'Barcode',
            th_barCode: 'Barcode',
            th_serialNumber: 'Serial Number',
            th_skuCode: 'SKU',
            th_userInfo: 'User Information',
            th_purchaseDate: 'Purchase Date',
            th_expireDate: 'Expiry Date Of Warranty Period',
            th_createTime: 'Product Registration Date',
            th_purchasePlace: 'Purchase Place',
            th_purchasedFrom: 'Purchase Place',
            th_opr: 'Operation',
        },
        productDetail: {
            label_nameEn: 'Product Name(EN)',
            label_nameTh: 'Product Name(TH)',
            label_barcode: 'Barcode',
            label_sku: 'SKU code',
            label_serviceMonth: 'Period Of Warranty(month)',
            label_remark:'Remark',
            label_serialNumber: 'Serial Number(optional)',
            label_purchasePlace: 'Channel Of Purchase',
            label_shopName: 'Shop',
            label_purchaseDate: 'Purchase Date',
            label_purchaseRecord: 'Purchase Record',
            label_createTime: 'Product Registration Date',
            label_expireDate: 'Expiry Date',
            label_contactName: 'Contact Name',
            label_contactMobile: 'Contact Phone',
            label_contactEmail: 'Contact Email',
            label_username: 'User Name',
            label_nickname: 'Nick Name',
            label_mobile: 'Mobile',
            label_email: 'Email',
            label_userCreateTime: 'Registration Date',
            label_productCount: 'Registered Product Count',
            input_confirm: 'Confirm',
            input_cancel: 'Cancel',
            header_goback: 'Go back',
            header_detail: 'Detail'
        },
    },

    activity: {
        form: {
            ph_searchTip: 'Please enter activity name',
            ph_status: 'Status',
            input_edit: 'Edit',
            input_detail: 'Details',
            input_delete: 'Delete',
            th_title: 'Activity Name',
            th_serviceMonth: 'Additional Warranty Period(month)',
            th_startDate: 'Product Registration Start Date',
            th_endDate: 'Product Registration End Date',
            th_status: 'Activity Status',
            th_productCount: 'Related Product Count',
            th_opr: 'Operation',
            label_detail: 'Detail',
        },
        detail: {
            label_registrationPeriod: 'Product Registration Period',
            label_serviceMonth: 'Additional Warranty Period(month)',
            label_productCount: 'Related Product Count',
            label_title: 'Activity Name',
            th_img: 'Product Picture',
            th_name: 'Product Name',
            th_code: 'Barcode',
            input_add: 'Add',
            input_delete: 'Delete',
            th_status: 'Status',
            label_add: 'Can be add',
            label_added: 'Added',
            ph_searchTip: 'Please enter the product name/barcode/sku to search',
        },
    },

    /**Product information (deprecated) */
    product: {
        product: 'Product information',
        tab_all: 'All products',
        tab_shelf: 'Already available',
        tab_review: 'Under review',
        tab_not_shelf: 'Not available',
        tab_draft: 'Draft',
        tab_deleted: 'Deleted',
        filter_stock: 'Available stock',
        filter_sold: 'Sales',
        filter_cost: 'Cost',
        input_search: 'Search',
        input_filter: 'Filter',
        input_sync: 'Sync inventory',
        input_add: 'Add product',
        th_barcode: 'Barcode',
        th_name: 'Product name',
        th_update: 'Last update time',
        th_stock: 'Total stock',
        th_cached: 'Buffer inventory',
        th_used: 'Occupy inventory',
        th_selling: 'Available to buy',
        th_sold: 'Sales',
        th_shelf: 'Number of stores on the shelf',
        th_state: 'State',
        th_oper: 'Operation',
        oper_edit: 'Edit',
        oper_more: 'More operations',
    },

    /**Component separation logic */

    //Picture/video/pdf input components, due to overlapping functions, put them together
    mediaInputs: {
        up_error: 'Upload error occurred',
        size_error: 'Do not upload empty files',
        img: {
            type_error: 'Please pass in an image!'
        },
        pdf: {
            type_error: 'Please pass in a PDF file!'
        },
        video: {
            type_error: 'Please pass in a video!'
        }
    },

    //Commodity input (strictly speaking, it is not a public component)
    prdInput: {
        step_1: '01. Product details',
        step_2: '02. Dimension',
        step_3: '03. Management Attributes',
        step_4: '04. Price details',
        step_5: '05. image details',
        step_6: '06. Product information',
        step_7: '07. After sales information',
        step_8: '08. Import&Certificate Information',
        require_brand: 'Please fill in the brand',
        require_barcode: 'Please fill in Barcode',
        require_name: 'Please fill in the product name',
        require_sku: 'Please fill in the SKU',
        require_month: 'Please fill in the month',
        require_way: 'Please fill in the after-sales way',
        require_partnerId: 'Please fill in the supplier',
        require_supplierId: 'Please fill in the supplier',
        require_weight: 'Please fill in the weight',
        require_height: 'Please fill in the height',
        require_width: 'Please fill in the width',
        require_length: 'Please fill in the length',
        label_source: 'Product Source',
        label_self: 'Normal',
        label_practicality: 'Consiagnment',
        label_virtual: 'Dropship',
        label_supplier: 'Supplier',
        label_barcode: 'Barcode',
        label_sku: 'SKU',
        label_name: 'Product name',
        label_brand: 'Brand',
        label_weight: 'Weight',
        label_height: 'Height',
        label_width: 'Width',
        label_length: 'Length',
        label_clip: 'Split Order',
        label_single_cost: 'Delivery Fee',
        label_garantee: 'Insurance',
        label_transFee: 'Free shipping',
        label_g: 'Gram',
        label_mm: 'Mm',
        label_thb: 'Thai',
        label_month: 'Month',
        label_yes: 'Yes',
        label_no: 'No',
        label_small: 'Small',
        label_big: 'Big size',
        label_persent: '%',
        label_stock_control: 'SN/IMEI Control In-Out',
        label_none: 'No',
        label_status: 'Disable/Enable',
        label_stock: 'Available stock',
        label_cost: 'Cost price',
        label_b2b: 'B2B',
        label_2b2c: 'S2B2C',
        label_vip: 'Vip price',
        label_online_app: 'Online And APP',
        label_kd_credit: 'KD Price(Credit)',
        label_kd_cash: 'Dealer Price',
        label_drop_ship: 'Drop Ship Price',
        label_credit: 'KD Price',
        label_cash: 'Dealer Price',
        label_offline_srp: 'Offline SRP',
        label_dayly: 'Daily Price',
        label_promotion: 'Promotion Price',
        label_flash_sale: 'Flash Sales Price',
        label_online_srp: 'Online SRP',
        label_mega_campain: 'Mega Campaign',
        label_is_vip: 'ON/OFF',
        label_is_fans: 'ON/OFF',
        label_fans: 'FANS price',
        label_cover: 'Cover',
        label_tag: 'Product label image',
        label_slider: 'Carousel',
        label_vido: 'Vido',
        label_size_hint: 'The size is between 330x330 and 5000x5000px',
        label_as_limit: 'Warranty Period',
        label_as_way: 'Service Type (multiple choices)',
        label_as_home: 'On-site Service(Great BKK Only)',
        label_repair: 'Repair',
        label_change: 'Replace',
        label_refund: 'Refund',
        label_have: 'Yes',
        label_pdf_upload: 'Upload PDF',
        label_hs_code: 'HS Code',
        label_import_duty: 'Normal Import duty',
        label_from_e: 'Use Form E/D/…',
        input_create: 'Confirm to create',
        input_create_next: 'Create and create the next one',
        input_cancel: 'Cancel',
        msg_price_change: '{1}, {0} have been recalculated',
        msg_sub_bysize: 'Due to size changes',
        msg_sub_bycash: 'Due to Dealer Price changes',
        msg_sub_bycredit: 'Due to KD Price(Credit) changes',
        label_cancel: 'Doing this operation will lose all current input, continue? ',
        dlg_priceAlert: 'All prices require a value greater than zero, please check your input. ',
        dlg_priceConfirm: 'All prices need to be filled with a value greater than zero. You have not done so at present, which may lead to failure of the review. Do you want to continue? ',
        label_warn: 'Warning',
        input_confirm: 'OK',
        // input_cancel: 'Cancel',
    },
    // paging
    pagination: {
        label_total: 'Total {0} per page',
    },
    //tab
    tabs: {
        tab_all: 'All products',
        tab_assoc: 'Associated product',
        tab_nonAssoc: 'Unassociated product',
        tab_inadequate: 'Insufficient stock',
        tab_exhausted: 'Out of stock',
        tab_deleted: 'Deleted item',
    },

}

export default { dlc };